export const ANCIA_CLIENT_ID = 1816
